import React from 'react';

// Loading state that keeps the folder layout's shape — rows resolve into the
// real list without a reflow, only the value-bearing parts shimmer.
const ChoresSkeleton = () => (
  <div className="space-y-4">
    {[0, 1, 2].map(i => (
      <div key={i} className="space-y-2">
        <div className="flex items-center gap-2 p-2">
          <div className="w-3 h-3 rounded-sm skeleton-shimmer" />
          <div className="h-3 w-24 rounded skeleton-shimmer" />
        </div>
        <div className="space-y-2">
          {[0, 1].map(j => (
            <div key={j} className="h-14 rounded-2xl skeleton-shimmer" />
          ))}
        </div>
      </div>
    ))}
  </div>
);

export default ChoresSkeleton;
